<template>
    <ac-modal ref="modal" :title="'Please provide a reason for declining the request.'" @ac-modal-closed="onModalClosed">
        <template>
            <div class="row">
                <div class="col-md-10">
                    <label for="response">Response</label>
                    <input type="text" id="response" class="form-control" v-model="declinedResponse">
                </div>
            </div>
        </template>
        <template slot="buttons">
            <ac-button type="button" class="btn btn-red btn-sm" :action="close">Cancel</ac-button>
            <ac-button type="button" class="btn btn-green btn-sm" :action="sendDeclinedResponse">Send Response</ac-button>
        </template>
    </ac-modal>
</template>

<script>
    import {api} from "../../../../global/framework/api.js";

    export default {
        name: "DeclineAffiliationModal",
        data() {
            return {
                affiliationId: 0,
                declinedResponse: '',
                resolveRef: null
            }
        },
        methods: {
            showModal(affiliationId) {
                this.declinedResponse = '';
                this.affiliationId = affiliationId;
                this.$refs.modal.open();
                return new Promise((resolve, reject) => {
                    this.resolveRef = resolve;
                });
            },
            close() {
                this.$refs.modal.close();
                this.resolveRef(false);
            },
            onModalClosed() {
                this.resolveRef(false);
            },
            async sendDeclinedResponse() {
                let result = await api.post('Affiliation', 'DeclineAffiliation', {
                    affiliationId: this.affiliationId,
                    response: this.declinedResponse
                });
                if (result) {
                    this.$refs.modal.close();
                    this.resolveRef(true);
                }
            }
        }
    }
</script>

<style scoped>

</style>